export class MerchantDefaults {
  attendance: boolean = true;
  cashDrawer: boolean = true;
  discount: boolean = true;
  fohSalesReports: boolean = true;
  menu: boolean = true;
  oloPayment: boolean = true;
  paymentType: boolean = true;
  role: boolean = true;
  seatView: boolean = true;
  tip: boolean = true;
  user: boolean = true;

  public load(data: any): this {

    Object.assign(this, data);
    return this;
  }
}
